import React from 'react';
import ReactMarkdown from "react-markdown";

import sourcecode from "../images/source-code.svg";

import github from "../json/github.json";

function GitHub() {
    function buildImageLink(link) {
        const images = [["sourcecode", sourcecode]];
        for (let i = 0; i < images.length; i++) {
            if (images[i][0] === link) {
                
                return images[i][1];
            }
        }
    }

    function buildHeaderLink(href, title, text) {
        if (href.length) {
            return (
               <h2 className="subtitle"><a href={href} title={title} target="_blank" rel="noopener noreferrer">{text}</a></h2>
            )
        } else {
            return (
               <h2 className="subtitle">{text}</h2>
            )
        }
    }

    return (
        <div className="content">
            <header>
                <h1 className="title has-text-centered has-text-white">My GitHub Repositories</h1>
                <p>
                    Some of the stuff I have done that have found their way to my GitHub account. All header links open in a new window or tab.
                </p>
            </header>

            {github.github.map((g, index = 0) => {
                return (
                    <section className="section" key={index++}>
                        <div className="columns">
                            <div className="column is-narrow">
                                <figure>
                                    <img className="image is-128x128" src={buildImageLink(g.img.src)} alt={g.img.alt} />
                                </figure>
                            </div>
                            <div className="column">
                                <div className="content">
                                    {buildHeaderLink(g.link.href, g.link.title, g.link.text)}
                                    <ReactMarkdown children={g.body} />
                                </div>
                            </div>
                        </div>

                    </section>
                )
            })}
        </div>
    )
}

export default GitHub;